<form [formGroup]="userFilterForm">
  <div class="form-content">
    <div class="pure-g filters-grid">
      <!-- User Name -->
      @if (visibleFilters.includes('userName')) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input label="User Name" placeholder="Enter user name" formControlName="userName" ngDefaultControl> </mc-input>
        </div>
      }

      <!-- Email -->
      @if (visibleFilters.includes('email')) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input label="Email" placeholder="Enter email" formControlName="email" ngDefaultControl> </mc-input>
        </div>
      }

      <!-- Full Name -->
      @if (visibleFilters.includes('fullName')) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input label="Full Name" placeholder="Enter full name" formControlName="fullName" ngDefaultControl> </mc-input>
        </div>
      }

      <!-- Role -->
      @if (visibleFilters.includes('role')) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select label="Role" placeholder="Select role" formControlName="role" ngDefaultControl>
            @for (role of rolesList; track role.value) {
              <mc-option [value]="role.value">
                {{ role.label }}
              </mc-option>
            }
          </mc-multi-select>
        </div>
      }

      <!-- Region -->
      @if (visibleFilters.includes('region')) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select label="Region" placeholder="Select region" formControlName="region" ngDefaultControl>
            @for (region of regionList; track region.value) {
              <mc-option [value]="region.value">
                {{ region.label }}
              </mc-option>
            }
          </mc-multi-select>
        </div>
      }

      <!-- Cluster -->
      @if (visibleFilters.includes('cluster') && clusterList.length > 0) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select label="Cluster" placeholder="Select cluster" formControlName="cluster" ngDefaultControl>
            @for (cluster of clusterList; track cluster.value) {
              <mc-option [value]="cluster.value">
                {{ cluster.label }}
              </mc-option>
            }
          </mc-multi-select>
        </div>
      }

      <!-- Status -->
      @if (visibleFilters.includes('isActive')) {
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-checkbox-group legend="Status">
            <div class="checkbox-row">
              <mc-checkbox label="Active" [checked]="isValueSelected(true)" (change)="onCheckChange(true)"> </mc-checkbox>

              <mc-checkbox label="Inactive" [checked]="isValueSelected(false)" (change)="onCheckChange(false)"> </mc-checkbox>
            </div>
          </mc-checkbox-group>
        </div>
      }

      <!-- Shop Code -->
      @if (visibleFilters.includes('shopCode')) {
        @if (activeTab === 0) {
          <!-- Shop-users tab: tag input (same as work order filter) -->
          <div class="pure-u-md-12-24 p-b-16 p-r-16">
            <app-aems-multiline-tag-input
              label="Shop Code(s)"
              [transformToUppercase]="true"
              placeholder="Enter shop code(s)"
              [regex]="shopCodeRegex"
              [heightInPixels]="65"
              formControlName="shopCode">
            </app-aems-multiline-tag-input>
          </div>
        } @else if (shopCodeList.length > 0) {
          <!-- Non-shop tab: multi-select populated from cluster cascade -->
          <div class="pure-u-md-12-24 p-b-16 p-r-16">
            <mc-multi-select label="Shop Code" placeholder="Select shop code" formControlName="shopCode" ngDefaultControl>
              @for (shop of shopCodeList; track shop.value) {
                <mc-option [value]="shop.value">{{ shop.label }}</mc-option>
              }
            </mc-multi-select>
          </div>
        }
      }
    </div>
  </div>

  <!-- Footer Buttons -->
  <div class="utility-buttons">
    <mc-button label="Apply Filters" appearance="primary" (click)="applyFilters()" (keydown)="applyFilters()"> </mc-button>

    <mc-button label="Clear Filters" appearance="neutral" (click)="clearFilters()" (keydown)="clearFilters()"> </mc-button>
  </div>
</form>
